// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SemainesBar_nom__1LDeX.SemainesBar_title__3fov8 {\n  flex: inherit;\n  max-width: 50%;\n  overflow: hidden;\n  font-size: 0.9rem;\n  text-overflow: ellipsis;\n  color: var(--background-creneau-normal);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Semaines/SemainesBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,uCAAuC;AACzC","sourcesContent":[".nom.title {\n  flex: inherit;\n  max-width: 50%;\n  overflow: hidden;\n  font-size: 0.9rem;\n  text-overflow: ellipsis;\n  color: var(--background-creneau-normal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nom": "SemainesBar_nom__1LDeX",
	"title": "SemainesBar_title__3fov8"
};
export default ___CSS_LOADER_EXPORT___;
